import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mode-auto-update-button',
  templateUrl: './auto-update-button.component.html',
  styleUrls: ['./auto-update-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutoUpdateButtonComponent {
  @Input() isAutoUpdate = true;
  @Output() updateIsAutoUpdateDisabled = new EventEmitter<boolean>();

  enableAutomaticUpdates() {
    this.updateIsAutoUpdateDisabled.emit(false);
  }
  enableManualUpdates() {
    this.updateIsAutoUpdateDisabled.emit(true);
  }
}
